module.exports = __webpack_public_path__ + "img/icon_Noreturn@2x.21f0af71.png";